































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import Project from '@/models/Project';
import ProjectServer from '@/models/ProjectServer';
import Mutations from '@/store/mutations';
import { EllipseCurve } from 'three';
import UserGroup from '@/models/UserGroup';
import User from '@/models/User';
import UserInfoController from '@/controllers/UserInfo'
import { UserQuestions } from '@/controllers/models/UserInfo';
import { Countries, Country, State } from '@/util/Geography'
import { TimelineSurveyResponses } from '@/controllers/models/TimelineSurveyResponses';

@Component
export default class DemographicQuestionsForm extends Vue
{
    @Prop({ default: false, type: Boolean }) readonly disabled!: boolean;

    loading = false;
    submitting = false;
    get shouldDisableFields()
    {
        return this.submitting || this.disabled;
    }

    questions : UserQuestions | null = null;
    
    usageOptions = [
        { value: '', text: 'No answer' },
        { value: 'School (K-12)', text: 'School (K-12)' },
        { value: 'University', text: 'University'},
        { value: 'Research', text: 'Research'},
        { value: 'Company', text: 'Company'},
        { value: 'Personal', text: 'Personal'},
        { value: 'other', text: 'Other (please fill in the text box below)'}
    ];

    selectedUsageOption : string | null = '';
    
    @Watch("selectedUsageOption")
    usageOptionChanged(value: string | null)
    {
        if (value == null) return;
        if (!this.questions) return;
        if (value == 'other')
        {
            if (!this.loading) this.questions.affiliation = '';
        }
        else
        {
            this.questions.affiliation = value;
        }
    }

    roleOptions = [
        { value: '', text: 'No answer' },
        { value: 'Student', text: 'Student' },
        { value: 'Educator', text: 'Educator'},
        { value: 'Researcher', text: 'Researcher'},
        { value: 'Professional', text: 'Professional'},
        { value: 'Individual', text: 'Individual'},
        { value: 'other', text: 'Other (please fill in the text box below)'}
    ];

    selectedRoleOption : string | null = '';

    @Watch("selectedRoleOption")
    roleOptionChanged(value: string | null)
    {
        if (value == null) return;
        if (!this.questions) return;
        if (value == 'other')
        {
            if (!this.loading) this.questions.role = '';
        }
        else
        {
            this.questions.role = value;
        }
    }

    get countryOptions()
    {
        let sortedList = Countries.sort((a, b) => 
        {
            if (a.name.trim() === 'United States') return -1;
            if (b.name.trim() === 'United States') return 1;
            return a.name.trim().localeCompare(b.name.trim(), undefined, {numeric: true, sensitivity: 'base'});
        });

        return [{ value: <any>null, text: 'No answer' }].concat(sortedList.map((a)=>{
            return { value: a, text: a.name };
        }));
    }

    selectedCountryOption : Country | null = null;

    @Watch("selectedCountryOption")
    countryChanged(value: Country | null)
    {
        if (!this.questions) return;
        if (!value)
        {
            this.questions.country = '';
            this.selectedStateOption = null;
            return;
        }
        
        this.questions.country = value.name;
        this.selectedStateOption = null;
    }

    get stateOptions()
    {
        if (this.selectedCountryOption == null) return [];
        
        const country = this.selectedCountryOption;
        const states = country.states;
        if (states.length > 1)
        {
            let sortedList = states.sort((a, b) => 
                {
                    return a.name.trim().localeCompare(b.name.trim(), undefined, {numeric: true, sensitivity: 'base'});
                });
            return [{value: <any>null, text: 'No answer'}].concat(sortedList.map(a=>{ return { value: a, text: a.name } }));
        }
        return [];
    }
    
    selectedStateOption : State | null = null;

    @Watch("selectedStateOption")
    stateChanged(value: State | null)
    {
        if (!this.questions) return;
        if (!value)
        {
            this.questions.state = '';
            return;
        }
        
        this.questions.state = value.name;
    }

    async submit()
    {
        this.submitting = true;
        try
        {
            if (!this.questions) return false;
            try
            {
                await UserInfoController.SetUserQuestions(this.questions);
            }
            catch(err)
            {
                const resp = (err as any).response;
                return resp.data;
            }
            return true;
        }
        finally
        {
            this.submitting = false;
        }
    }

    @Watch("user")
    onUserChanged(val: User, oldVal: User)
    {
        this.refresh();
    }

    mounted()
    {
        this.refresh();
    }

    async refresh()
    {
        try
        {
            this.loading = true;
            if (this.user == null) return;
            try
            {
                this.$set(this, "questions", await UserInfoController.GetUserQuestions());
            }
            catch(err)
            {
                console.error(err);
                // TODO: Notify of failure
            }
            
            if (!this.questions)
            {
                this.$set(this, "questions", new UserQuestions);
                this.usageOptionChanged(this.selectedUsageOption);
                this.roleOptionChanged(this.selectedRoleOption);
                this.countryChanged(this.selectedCountryOption);
                this.stateChanged(this.selectedStateOption);
            }
            else
            {
                this.selectedUsageOption = null;
                this.selectedRoleOption = null;

                if (this.questions.affiliation == '')
                {
                    this.selectedUsageOption = '';
                }
                else
                {
                    for(let k of this.usageOptions)
                    {
                        if (k.value == this.questions.affiliation)
                        {
                            this.selectedUsageOption = k.value;
                            break;
                        }
                    }
                }

                if (this.questions.role == '')
                {
                    this.selectedRoleOption = '';
                }
                else
                {
                    for(let k of this.roleOptions)
                    {
                        if (k.value == this.questions.role)
                        {
                            this.selectedRoleOption = k.value;
                            break;
                        }
                    }
                }

                if (this.selectedUsageOption == null)
                {
                    this.selectedUsageOption = 'other';
                }

                if (this.selectedRoleOption == null)
                {
                    this.selectedRoleOption = 'other';
                }
                
                this.usageOptionChanged(this.selectedUsageOption);
                this.roleOptionChanged(this.selectedRoleOption);

                // Countries/States
                {
                    const country = this.questions.country;
                    const state = this.questions.state;

                    if (country == '')
                    {
                        this.countryChanged(this.selectedCountryOption);
                        this.stateChanged(this.selectedStateOption);
                        return;
                    }

                    for(let k of this.countryOptions)
                    {
                        if (k.text == country)
                        {
                            this.$set(this, 'selectedCountryOption', k.value);
                            break;
                        }
                    }

                    if (this.selectedCountryOption != null)
                    {
                        this.countryChanged(this.selectedCountryOption);

                        let tgState : any = this.selectedStateOption;
                        for (let k of this.stateOptions)
                        {
                            if (k.text == state)
                            {
                                tgState = k.value;
                                break;
                            }
                        }
                        
                        console.log(this.selectedStateOption);
                        this.stateChanged(this.selectedStateOption);
                        this.$nextTick(()=>{
                            this.$set(this, 'selectedStateOption', tgState);
                        });
                    }
                }
            }
        }
        finally
        {
            this.$nextTick(()=>{
                this.loading = false;
            })
        }
    }
}
